<template>
  <el-container style="width:100%;">
    <el-header>
      <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
      <el-button round @click="onCreate">{{generateCustomizeString('addCompany')}}</el-button>
    </el-header>
    <el-main style="height:100%; margin-bottom:60px;">
      <el-table
        :data="ExpressCompanies"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading.body="fetchAllExpressCompaniesLoading"
      >
        <el-table-column :label="generateCustomizeString('companyName')" prop="name"></el-table-column>
        <el-table-column :label="generateCustomizeString('queryUrl')" prop="order_query_url"></el-table-column>
        <el-table-column :label="generateCustomizeString('isDefault')" prop="is_default">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.is_default === 1"
              type="success"
              close-transition
            >{{generateCustomizeString('defaultCompany')}}</el-tag>
            <el-button
              type="text"
              size="medium"
              @click="selectDefault(scope.row.id)"
              v-else
            >{{generateCustomizeString('selectDefault')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="medium"
              @click="deleteClick(scope.row.id, scope.row.express_company_id)"
            >{{generateCustomizeString('delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="generateCustomizeString('addCompany')"
        :visible.sync="createDialogVisiable"
        width="40%"
        :append-to-body="true"
      >
        <el-form ref="form" :model="form" class="detailForm" label-position="right">
          <div style="margin: 0 30px;">
            <el-form-item :label="generateCustomizeString('expressCompany')">
              <el-select
                v-model="form.express_company_id"
                style="width: 70%;"
                @change="checkCompany"
              >
                <el-option
                  v-for="item in companyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <div
                v-show="this.checkStatus === 1"
                style="padding-left: 68px; margin-bottom: -30px; font-size: 12px; color: red;"
              >{{ generateCustomizeString('CourierCompanyExist') }}</div>
            </el-form-item>
            <el-form-item style="margin-top: 40px;">
              <div style="text-align: center;">
                <el-button
                  type="primary"
                  @click="confirmCreate"
                  style="width: 80px;"
                  v-if="this.checkStatus === 1"
                  disabled
                >{{generateCustomizeString('addNew')}}</el-button>
                <el-button
                  type="primary"
                  @click="confirmCreate"
                  style="width: 80px;"
                  v-else
                >{{generateCustomizeString('addNew')}}</el-button>
                <el-button
                  @click="onCancel"
                  style="width: 80px; margin-left: 30px;"
                >{{generateCustomizeString('cancel')}}</el-button>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>
      <el-dialog
        :title="generateCustomizeString('selectDefaultCompany')"
        :visible.sync="updateDialogVisiable"
        width="30%"
        :append-to-body="true"
      >
        <div style="text-align: center;">
          <el-button
            type="primary"
            @click="updateExpressCompany"
            style="width: 80px;"
          >{{generateCustomizeString('confirm')}}</el-button>
          <el-button
            @click="this.updateDialogVisiable = false"
            style="width: 80px; margin-left: 50px;"
          >{{generateCustomizeString('cancel')}}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="generateCustomizeString('deleteExpressCompany')"
        :visible.sync="deleteDialogVisiable"
        width="30%"
        :append-to-body="true"
      >
        <div style="text-align: center;">
          <el-button
            type="primary"
            @click="deleteExpressCompany"
            style="width: 80px;"
          >{{generateCustomizeString('confirm')}}</el-button>
          <el-button
            @click="this.deleteDialogVisiable = false"
            style="width: 80px; margin-left: 50px;"
          >{{generateCustomizeString('cancel')}}</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'ExpressCompanyList',
  data() {
    return {
      fetchAllExpressCompaniesLoading: false,
      createDialogVisiable: false,
      updateDialogVisiable: false,
      deleteDialogVisiable: false,
      ExpressCompanies: [],
      companyId: null,
      selectId: null,
      deleteId: null,
      companyStatus: 0,
      isDefault: 0,
      express_company_id: null,
      companyOptions: [],
      form: {
        express_company_id: '',
        is_default: 0
      },
      checkStatus: 0
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchExpressCompaniesList()
    },
    onCreate() {
      this.checkStatus = 0
      this.form.express_company_id = null
      this.createDialogVisiable = true
      this.fetchExpressCompany()
    },
    onCancel() {
      this.createDialogVisiable = false
      this.form.express_company_id = null
    },
    confirmCreate() {
      this.createExpressCompany(this.form)
    },
    selectDefault(selectId, companyId) {
      this.updateDialogVisiable = true
      this.selectId = selectId
      this.companyId = companyId
      console.log(selectId)
    },
    // confirmUpdate() {
    //   this.updateExpressCompany()
    // },
    deleteClick(deleteId) {
      this.deleteDialogVisiable = true
      this.deleteId = deleteId
    },
    checkCompany() {
      for (var i = 0; i < this.ExpressCompanies.length; i++) {
        if (
          this.form.express_company_id ===
          this.ExpressCompanies[i].express_company_id
        ) {
          this.checkStatus = 1
          break
        } else {
          this.checkStatus = 0
        }
      }
    },
    fetchExpressCompaniesList() {
      if (this.fetchAllExpressCompaniesLoading) return
      this.fetchAllExpressCompaniesLoading = true
      request({
        url: 'express/shop/company/list',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.express_company_id = response.data[i].express_company_id
            obj.name = response.data[i].company.name
            obj.order_query_url = response.data[i].company.order_query_url
            obj.is_default = response.data[i].is_default
            data[i] = obj
          }
          this.ExpressCompanies = data
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchAllExpressCompaniesLoading = false
        })
    },
    fetchExpressCompany() {
      request({
        url: 'express/company/list?status=1',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.value = response.data[i].id
            obj.label = response.data[i].name
            data[i] = obj
          }
          this.companyOptions = data
        })
        .catch(error => {
          console.warn(error)
        })
    },
    createExpressCompany(data) {
      request({
        url: 'express/shop/company',
        method: 'post',
        data
      })
        .then(response => {
          this.fetchExpressCompaniesList()
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.createDialogVisiable = false
          this.form.express_company_id = null
        })
    },
    updateExpressCompany() {
      var data = {
        express_company_id: this.companyId,
        is_default: 1
      }
      request({
        url: 'express/shop/company/' + this.selectId,
        method: 'patch',
        data
      })
        .then(response => {
          this.fetchExpressCompaniesList()
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.updateDialogVisiable = false
        })
    },
    deleteExpressCompany() {
      request({
        url: 'express/shop/company/' + this.deleteId,
        method: 'delete'
      })
        .then(response => {
          this.fetchExpressCompaniesList()
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.deleteDialogVisiable = false
        })
    }
  },
  created() {
    this.fetchExpressCompaniesList()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
